export default [
  {
    path: '/login',
    name: 'auth.login',
    meta: {
      title: 'general.login',
      public: true,
      redirectIfAuth: true
    },
    component: () => import(`@/views/Auth/Login.vue`)
  },
  {
    path: '/loginas/:authenticate',
    name: 'auth.loginas',
    meta: {
      title: 'general.login',
      public: true,
      redirectIfAuth: true
    },
    component: () => import(`@/views/Auth/LoginAs.vue`)
  },
  {
    path: '/register',
    name: 'auth.register',
    meta: {
      title: 'general.register',
      public: true,
      redirectIfAuth: true
    },
    component: () => import(`@/views/Auth/Register.vue`)
  },
  {
    path: '/activation/:token',
    name: 'auth.activation',
    meta: {
      title: 'general.activationTitle',
      public: true,
      redirectIfAuth: true
    },
    component: () => import(`@/views/Auth/Activation.vue`)
  },
  {
    path: '/reset',
    name: 'auth.reset',
    meta: {
      title: 'general.resetPasswordTitle',
      public: true,
      redirectIfAuth: true
    },
    component: () => import(`@/views/Auth/Reset.vue`)
  },
  {
    path: '/new-password/:token',
    name: 'auth.newPassword',
    meta: {
      title: 'general.createPasswordTitle',
      public: true,
      redirectIfAuth: true
    },
    component: () => import(`@/views/Auth/NewPassword.vue`)
  },
  {
    path: '/create-password/:token',
    name: 'auth.createPassword',
    meta: {
      title: 'general.createPasswordTitle',
      public: true,
      redirectIfAuth: true,
      create: true
    },
    component: () => import(`@/views/Auth/NewPassword.vue`)
  },
  {
    path: '/personal/register',
    name: 'auth.personal.register',
    meta: {
      title: 'general.createPasswordTitle',
      public: true,
      redirectIfAuth: true
    },
    component: () => import(`@/views/Auth/PersonalRegister.vue`)
  }
]
